<template>

	<div class="main-contents">
		<div class="mem_container">
			<div class="mem_info_contents">
				<div class="mem_contents_header">
					<div class="title-txt">내 프로젝트<br/></div>
				</div>
				<div class="tec_prj_tab">
					<div class="tab-type5">
						<ul class="tab">
							<li @click="pageMove('PRJ104M01')">관심/지원 프로젝트</li>
							<li :class="input.pageId == '2' ? 'on':''" @click="clickTab('PRJ102M01')">
								<a>참여 프로젝트 </a>
							</li> 
							<li :class="input.pageId == '3' ? 'on':''" @click="clickTab('PRJ102M03')">
								<a>완료 프로젝트 </a>
							</li> 
							<li @click="pageMove('PRJ103M01')">내 인터뷰</li>
						</ul>
					</div>
				</div>
				<div class="contents-body tecprj">
					<div class="search-box">
						<div class="box-line">
							<SelectComp type="select" class="select_wrap prj_name" list="1:프로젝트명,2:수행사명" v-model="input.searchGubun"/>						
							<InputComp type="text" classNm="search_box int" :placeholder="input.searchGubun == '1' ? '프로젝트명' : '수행사명'" v-model="input.searchKeyword" @keyup.enter="getList('1')"  />
							<div class="search_btn" >
								<img class="search" src="/images/icon_srch.png" alt="검색버튼" @click="getList('1')"/>
							</div>
						</div>

						<div v-if="input.pageId == '2'" class="prj_tit mt-10"><span class="prj_cnt">{{projectCount.projectIngCount}}개</span>의 참여 프로젝트</div>
						<div v-if="input.pageId == '3'" class="prj_tit mt-10"><span class="prj_cnt">{{projectCount.projectEndCount}}개</span>의 완료 프로젝트</div>
					</div>

					<!-- <div class="filter">
						<div class="filter_box">
							<ul>
							<li><p class="text">NO.</p></li>
							</ul>
						</div>
					</div> -->

					<div v-for="(project) in projectList" :key="project.projectSeq" class="project_box">
						
						<div class="prj_pf box-hover">
							<div class="flex mb-5">
								<!-- <div class="no">{{ (pageInfo.pageIndex - 1) * pageInfo.pageUnit + (index + 1)}}</div> -->

								<div v-if="project.projectRecrStatus == '1'" class="state_mark">참여중</div>
								<div v-if="project.projectRecrStatus == '2'" class="state_mark ep">참여예정</div>
								<div v-if="project.projectRecrStatus == '9'" class="state_mark cp">완료</div>
							</div>

							<div class="prj_contents">
								<div class="regi">
									<!-- <div class="tit int_prj">프로젝트명</div> -->
									<div class="name prj-tit-hover"  @click="clickProjectInfo(project.projectSeq)">{{project.projectNm}}</div>
									<div class="int_box">
										<!-- <div class="list-view int_prj">
											<div class="label">개요</div>
											<div class="list text">{{project.projectDtlDesc}}</div>
										</div> -->
										<div class="list-view int_prj">
											<div class="label">
												<p>고 객 사</p>
											</div>
											<div class="list">
												<div class="add">{{project.clientNm}}</div>
												<div class="loca"><img src="/images/location.png" alt="위치" />{{project.projectLocCont}}</div>
											</div>
										</div>
										<!-- <div class="list-view int_prj">
											<div class="label">산업분야</div>
											<div class="list" style="display: inline-block !important;"><SelectComp type="text" cdId="PRO105" :value="project.indtypeFilterCd"/> / <SelectComp type="text" cdId="PRO143" :value="project.indtypeClassCd"/></div>
										</div> -->
									</div>
								</div>
								<div class="int_box">                                            
									<div class="list-view int_prj">
										<div class="label">
											<p>수 행 사</p>
										</div>
										<div class="list text">{{project.corpNm}}</div>
									</div>
									<div class="list-view int_prj">
										<div class="label">
											<p>개 발 기 간</p>
										</div>
										<div class="list">{{project.projectStartEndYyyymmdd}}</div>
									</div>
									<div class="list-view int_prj">
										<div class="label">
											<p>직 무 분 야</p>
										</div>
										<div class="list">
											<ul class="duty-list">
												<li v-for="(duty, index) in project.dutyList" :key="index">
													<span>
														<SelectComp type="text_comma_split" cdId="PRO141" :value="duty.dutyFilterCd"/>/<SelectComp type="text_comma_split" cdId="PRO142" :value="duty.dutyFieldCd"/>
													</span>
												</li>
											</ul>
										</div>
									</div>
									<div class="list-view int_prj mb-0">
										<div class="label">
											<p>개 발 기 술</p>
										</div>
										<div class="list text">{{project.devTechCont}}</div>
									</div>                                           
								</div>
							</div>
							<ProjectRecrRate type="MyPrj" :recrStartYyyymmdd="project.joinStartYyyymmdd" :recrEndYyyymmdd="project.joinEndYyyymmdd" :workCont="project.workCont"/>
						</div>
					</div>

					 <!-- 관련 내용이 없을 경우 -->
					 <div v-if="pageInfo.totalRecordCount == 0" class="project_box">
						<div class="prj_pf none">
							관련 내용이 존재하지 않습니다.
						</div>
					</div>

					<!--페이징 컴포넌트 -->
					<PagingComp :pageInfo="pageInfo" @page-click="goPage"/>
					<!--// 페이징 컴포넌트 -->

				</div>
			</div>
		</div>
	</div>

</template>

<script>

import PagingComp from '@/components/PagingComp.vue';
import ProjectRecrRate from '@/components/highpro/ProjectRecrRate.vue';

export default {

	components : {
		PagingComp,
		ProjectRecrRate
	},

	data() {
		return {
			input: {
				pageIndex : '1',
				searchGubun : '1',	// 1:프로젝트명, 2:수행사명,
				searchKeyword : '',
				pageId : this.$route.name || '' ,
			}, // 검색조건		

			userInfo : {
				birthYyyymmdd : ''
			},
			projectList : [],
			pageInfo : {},
			projectCount : {},
		};
	},
	bforeCreate() {
		// console.log('beforeCreate');
	},
	created() {
		// console.log('created');
	},
	beforeMount() {
		// console.log('beforeMount');
		// console.log("!!pageId : " + this.input.pageId);
		if(this.input.pageId == 'PRJ102M01'){
            this.input.pageId = '2';
        }
		else{
            this.input.pageId = '3';
        }

		// console.log(window);
	},
	mounted() {
		// console.log('mounted');

		this.userInfo = this.$store.state.userInfo;

		this.getList();
	},
	beforeUpdate() {
		// console.log('beforeUpdate');
	},
	updated() {
		// console.log('update');
	},
	beforeDestroy() {
		// console.log('beforeDestroy');
	},
	destroyed() {
		// console.log('destroyed');
	},

	methods: {
		
		getList(div) {
			if(div) this.input.pageIndex = 1;
			
			// console.log("pageId : " + this.input.pageId);
			this.$.httpPost('/api/prj/tec/getMyProjectList', this.input)
				.then(res => {
					// console.log(res.data);
					this.projectList 	= res.data.list;
					this.pageInfo 		= res.data.pageInfo;
					this.projectCount	= res.data.projectCount;

					for(var i in this.projectList){
						
						if(this.projectList[i].dutyFieldCont){
							var tempArr = this.projectList[i].dutyFieldCont.split(',');
							this.projectList[i].dutyList = [];

							for(var j in tempArr){
								this.projectList[i].dutyList.push({dutyFilterCd : tempArr[j].substr(0,2),
																  	   dutyFieldCd  : tempArr[j]});
							}
						}

					}

					window.scroll(0, 0);
				})
				.catch(err => {
					// console.log('============================='); 
					// console.log(err);
					// console.log(err.response);
					// console.log('============================='); 

					alert(err.response.data.error_description);
				});
		},

		goPage(page) {
			// console.log(page);
			this.input.pageIndex = page;
			this.getList();
		},
		pageMove(name) {
			// console.log('name', name);
			this.$router.move(name);
		},

		clickProjectInfo(projectSeq) {
			var param = {
				projectSeq : projectSeq
			};
			this.$.popup('/tec/prj/PRJ102P01', param, {width:0, height:0})
				// .then(res => {})
				// .catch(err => {})
				;
		},

		clickTab(page){
			if(this.$route.name != page){
				this.$router.push({name: page});
			}
			
		},
	},
};
</script>
